export default {
    apiGateway: {
        REGION: 'eu-west-1',
        endpoint: 'https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com',
    },
    cognito: {
        REGION: 'eu-west-1',
        USER_POOL_ID: 'eu-west-1_mTvG9Uoaw',
        APP_CLIENT_ID: '4dkldlh0np63854p9o9li8l48r',
    },
    apiDomain: 'api-pdcvallcompanys.com',
};
